export default {"src":"/_next/static/media/defaultSmallSalvage.21ac04ab.svg","height":100,"width":136};